export const TransactionsOnboarding = [
  {
    title: "Registra otras transacciones de dinero realizadas en tu empresa",
    description:
      "Lleva el control de otras transacciones de dinero como registro de prestamos, recepción de inversiones, transacciones a la entidad tributaria de tu país, entre otros.<br/><br/>Si quieres aprender más sobre cómo utilizar la sección transacciones haz <a href='https://symfonia.io/ayuda/contabilidad/agregar-transacciones'>clic aquí.</a>",
    image: "https://cdn01.prd.symfonia.io/Gifs/Transacciones-min.gif",
    alt: "Transacciones",
  },
];
